"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CondoPolicyCoverageTypes = exports.CondoPolicyCoverages = void 0;
const PropertyPolicyCoverageTypes_1 = require("./PropertyPolicyCoverageTypes");
var CondoPolicyCoverages;
(function (CondoPolicyCoverages) {
    CondoPolicyCoverages["DWELLING_UNIT_OWNERS"] = "Dwelling - Unit Owners";
})(CondoPolicyCoverages = exports.CondoPolicyCoverages || (exports.CondoPolicyCoverages = {}));
exports.CondoPolicyCoverageTypes = Object.assign(CondoPolicyCoverages, PropertyPolicyCoverageTypes_1.PropertyPolicyCoverageTypes);
